import * as consts from './VideoConsts';

const initialState = {
    videos: [],
    videoType: '',
    embedTitle: '',
    walkthruVideo: ''
};

const video = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default video;
